import { Pipe, PipeTransform } from '@angular/core';
import type { Menu } from '../../../../../models/menu/menu';

/**
 * The base menu can't be an abstract class due to deserialization techniques used for polymorphic deserialization.
 * Therefore, the abstract method `getAdobeFontFamilyCssUrl` is implemented on the extended abstract classes.
 * This technically means that all the menu objects have this method, but the type system doesn't know that.
 * Therefore, cast the menu to and then call the method if it exists.
 */
@Pipe({
  name: 'getAdobeFontFamilyCssUrl',
  standalone: false
})
export class GetAdobeFontFamilyCssUrlPipe implements PipeTransform {
  transform(value: Menu): string | null {
    return (value as any)?.getAdobeFontFamilyCssUrl?.() || null;
  }
}
